// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__LyoMw","main":"index_main___2dU_","collapseContent":"index_collapseContent__Qf7_m"};